module.exports = __webpack_public_path__ + "assets/images/novasport_1.3ac2c9c856483a94cdaa9612fd2379eb.png";